/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface AdminState {
    tabId: 0 | 1;
}

const initialState: AdminState = {
    tabId: 0,
};

export const adminSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {
        setAdminTabId: (state, action: PayloadAction<0 | 1>) => {
            state.tabId = action.payload;
        },
    },
});

export const { setAdminTabId } = adminSlice.actions;

export const selectAdminTabId = (state: RootState) => state.admin.tabId;

export default adminSlice.reducer;
